import { render, staticRenderFns } from "./BasketList.vue?vue&type=template&id=16bf4ab4&scoped=true&"
import script from "./BasketList.vue?vue&type=script&lang=js&"
export * from "./BasketList.vue?vue&type=script&lang=js&"
import style0 from "./BasketList.vue?vue&type=style&index=0&id=16bf4ab4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bf4ab4",
  null
  
)

export default component.exports